export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_jp-32b711a51086b964bcbca6e1ee341342.webp";